module.exports = __webpack_public_path__ + "img/vmc-icon.a2a0931e.png";